import { render, staticRenderFns } from "./GPT3.vue?vue&type=template&id=1778f0ba&scoped=true"
import script from "./GPT3.vue?vue&type=script&lang=js"
export * from "./GPT3.vue?vue&type=script&lang=js"
import style0 from "./GPT3.vue?vue&type=style&index=0&id=1778f0ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1778f0ba",
  null
  
)

export default component.exports